import { render } from "./VehicleScroller.vue?vue&type=template&id=c46a13f2"
import script from "./VehicleScroller.vue?vue&type=script&lang=js"
export * from "./VehicleScroller.vue?vue&type=script&lang=js"

import "./VehicleScroller.vue?vue&type=style&index=0&id=c46a13f2&lang=css"
script.render = render

export default script